import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MobileNavService } from '../../../services/mobile-nav.service';

@Component({
  selector: 'app-mobile',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './mobile.html',
  styleUrl: './mobile.css',
})
export class Mobile {
  openItem: string | null = null;

  constructor(
    public mobileNav: MobileNavService,
    public translate: TranslateService,
  ) {}

  toggleSub(key: string, event: Event): void {
    event.preventDefault();
    this.openItem = this.openItem === key ? null : key;
  }

  isOpen(key: string): boolean {
    return this.openItem === key;
  }

  switchLanguage(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem('preferredLanguage', lang);
    const html = document.documentElement;
    html.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    html.setAttribute('lang', lang);
    this.mobileNav.close();
  }
}
